import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TawkToChat = () => {
  const location = useLocation();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Don't load on admin page (/lina)
    if (location.pathname.startsWith('/lina')) {
      // Hide widget if navigating to admin
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
      return;
    }

    // Show widget if already loaded
    if (loaded) {
      if (window.Tawk_API && window.Tawk_API.showWidget) {
        window.Tawk_API.showWidget();
      }
      return;
    }
    
    // Check if script already exists
    if (document.querySelector('script[src*="tawk.to"]')) {
      if (window.Tawk_API && window.Tawk_API.showWidget) {
        window.Tawk_API.showWidget();
      }
      setLoaded(true);
      return;
    }

    // Fetch settings and load
    fetch(`${BACKEND_URL}/api/chat-settings`)
      .then(res => res.json())
      .then(settings => {
        if (!settings?.enabled || !settings.tawk_property_id) {
          return;
        }

        // Use single widget (English as default)
        const widgetId = settings.tawk_widget_id_en || settings.tawk_widget_id_fr;
        
        if (!widgetId) {
          return;
        }
        
        // Standard Tawk.to embed
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();

        const s1 = document.createElement('script');
        s1.async = true;
        s1.src = `https://embed.tawk.to/${settings.tawk_property_id}/${widgetId}`;
        s1.charset = 'UTF-8';
        
        const s0 = document.getElementsByTagName('script')[0];
        s0.parentNode.insertBefore(s1, s0);
        
        setLoaded(true);
      })
      .catch(() => {});
  }, [loaded, location.pathname]);

  return null;
};

export default TawkToChat;
